import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
// eslint-disable-next-line no-unused-vars
import { createLogger } from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import rootReducer from './reducers/rootReducer';

const persistConfig =
{
	key             : 'root',
	storage         : storage,
	stateReconciler : autoMergeLevel2,
	blacklist       : [ 'sessions', 'userStatus' ]
};

const reduxMiddlewares =
[
	thunk
];

// Uncomment to enable redux-logger in development
// if (process.env.NODE_ENV !== 'production')
// {
// 	const reduxLogger = createLogger(
// 		{
// 			duration  : true,
// 			timestamp : false,
// 			level     : 'log',
// 			logErrors : true
// 		});

// 	reduxMiddlewares.push(reduxLogger);
// }

const pReducer = persistReducer(persistConfig, rootReducer);

// Enable Redux DevTools Extension if available
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
	pReducer,
	composeEnhancers(applyMiddleware(...reduxMiddlewares))
);

export const persistor = persistStore(store);